



















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import {isCanShowAdCourse} from '@/utils/utils';

@Component({
  components: {
  }
})
export default class Home extends Vue {
  private activedTab = 'ktpCourse';
  private env: 'production' | '' = process.env.NODE_ENV;
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }

  @Watch('$route', { immediate: true, deep: true })
  private changeRouter(route: any) {
    const list = ['discover','ktpCourse', 'ktpMessage', 'ktpMy', 'ktpInfo', 'todoList','funny'];
    list.forEach(item => {
      if (new RegExp(item).test(route.path)) {
        this.$nextTick(() => {
          this.activedTab = item;
        });
        return;
      }
    });
  }

  handleBarChange() {
    if (this.$route.name === this.activedTab) return;
    if (window.localStorage.getItem('urlCache') as string) {
      this.$router.push(window.localStorage.getItem('urlCache') as string)
      window.localStorage.removeItem('urlCache')
      return
    }
    this.$router.push(this.activedTab);
  }

  created() {
    this.$router.onReady(() => {
      this.activedTab = this.$route.name as string;
      if (/home/.test(this.activedTab)){
        //如果是北京大学，直接定位到课堂页面
        let school:any = this.userInfo.school;
        let isCanShow = isCanShowAdCourse(school);
        //过滤掉
        if (this.userInfo.usertype == '0') {
           if(isCanShow){
             this.activedTab = 'ktpCourse';//有广告页面  ktpStudentHome ,目前先不直接启用
           }else{
             this.activedTab = 'ktpCourse';
           }
        }else{
           this.activedTab = 'ktpCourse';
        }
      }
      this.handleBarChange();
    });
    this.$store.state.courseInfo = {}
  }
}
